<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search search_box">
                <el-form :model="searchForm" inline size="small">
                    <el-form-item label="规则名称">
                        <el-input v-model="searchForm.input"
                                  @change="getTableData"
                                  class="width_220"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="getTableData" type="primary">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <el-button size="small" @click="activityPush">活动推送</el-button>
                <el-button size="small" @click="push_now">立即更新</el-button>
            </div>
        </div>

        <div class="table">
            <table border="0" style="border-spacing: 0">
                <tr class="table_th">
                    <th class="left_th first_th">
                        <div>操作</div>
                    </th>
                    <th class="left_th">
                        <div class="lang_left_th">名称</div>
                    </th>
                    <th class="left_th">
                        <div>触发事件</div>
                    </th>
                    <th class="left_th">
                        <div>推送内容</div>
                    </th>
                    <!-- <th class="left_th">
                        <div>内容顺序</div>
                    </th> -->
                    <th class="left_th">
                        <div>目标人员</div>
                    </th>
                    <th class="left_th">
                        <div>时间类型</div>
                    </th>
                    <!--<th class="left_th">
                        <div>时间粒度</div>
                    </th>-->
                    <th class="left_th">
                        <div>推送时间</div>
                    </th>
                    <th class="left_th">
                        <div>模板</div>
                    </th>
                    <th class="left_th">
                        <div class="th_text">治疗周</div>
                        <div class="th_text">Cycle</div>
                        <div class="bottom_text">T次</div>
                    </th>
                    <th class="text_width_1"
                        v-for="(item, index) in columnData"
                        :key="index">
                        <div class="th_text">
                            <div v-for="(item_c, index_c) in item.cycle_list"
                                 :key="index_c"
                                 class="cycle_item">
                                <div class="th_text">
                                    <div v-for="(item_w, index_w) in item_c.week_month_list"
                                         :key="index_w"
                                         class="week_item">
                                        <div :class="item_c.week_month_list.length-1===index_w
                                        && item.cycle_list.length-1===index_c
                                        ?'last_text':''"
                                             class="item_text top_text">
                                            {{item_w.name}}
                                        </div>
                                    </div>
                                </div>
                                <div :class="item.cycle_list.length-1===index_c?'last_text':''"
                                     class="item_text">
                                    {{item_c.name}}
                                </div>
                            </div>
                        </div>
                        <div class="bottom_text">{{item.name}}</div>
                    </th>
                </tr>

                <tr class="table_td"
                    v-for="(item, index) in tableData"
                    :class="edit_row_index === index ? 'table_edit_row' : ''"
                    :key="index">
                    <td class="first_td">
                        <div v-if="edit_row_index === index">
                            <span class="btn_text submit_btn"
                                  @click="submitRow(item)">
                                保存
                            </span>
                            <span class="btn_text add_text"
                                  @click="cancelRow(item, index)">
                                取消
                            </span>
                        </div>
                        <div v-else>
                            <span v-show="item.status == 1"
                                  @click="editRow(item, index)"
                                  class="btn_text edit_btn">
                                编辑
                            </span>
                            <span v-show="item.status == 1"
                                  @click="upLineRow(item)"
                                  class="btn_text submit_btn">
                                发布
                            </span>
                            <span v-show="item.status == 1"
                                  @click="delRow(item)"
                                  class="btn_text down_line">
                                删除
                            </span>
                            <span v-show="item.status == 2"
                                  @click="downLineRow(item)"
                                  class="btn_text down_line">
                                下线
                            </span>
                        </div>
                    </td>
                    <td>
                        <span v-if="edit_row_index != index">{{item.name}}</span>
                        <el-input class="width_all_100 no_border_radius"
                                  v-else
                                  size="small"
                                  v-model="item.name"></el-input>
                    </td>
                    <td>
                        <!-- 触发事件 -->
                        <div class="select_box">
                            <span class="left_text">{{originalEventList[item.event_name]}}</span>
                            <div v-if="edit_row_index === index"
                                 class="right_icon">
                                <el-dropdown @command="(v) => selectType(v, index, 'event_name')"
                                             trigger="click" placement="bottom">
                                    <span class="el-dropdown-link">
                                      <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item_event, index_event) in eventList"
                                                          :command="item_event.value"
                                                          :key="index_event">
                                            {{item_event.label}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </td>
                    <td>
                        <!--推送内容-->
                        <div class="select_box">
                            <span class="left_text">{{item.content_type | filter_content_type}}</span>
                            <div v-if="edit_row_index === index"
                                 class="right_icon">
                                <el-dropdown @command="(v) => selectType(v, index, 'content_type')"
                                             trigger="click">
                                    <span class="el-dropdown-link">
                                      <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item_d, index_d) in push_text"
                                                          :command="item_d.value"
                                                          :key="index_d">
                                            {{item_d.name}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </td>
                    <!-- <td>
                        内容顺序
                        <div class="select_box">
                            <span class="left_text">{{item.content_order | filter_content_order}}</span>
                            <div v-if="edit_row_index === index"
                                 class="right_icon">
                                <el-dropdown @command="(v) => selectType(v, index, 'content_order')"
                                             trigger="click">
                                    <span class="el-dropdown-link">
                                      <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item_d, index_d) in sort_text"
                                                          :command="item_d.value"
                                                          :key="index_d">
                                            {{item_d.name}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </td> -->
                    <td>
                        <!--目标人员-->
                        <div class="dialog_btn"
                             @click="selectTarget(item,index, 'target_type')">
                            {{item | filter_target_type}}
                        </div>
                    </td>
                    <td>
                        <div class="select_box">
                            <span class="left_text">{{item.cycle_type | filter_cycle_type}}</span>
                            <div v-if="edit_row_index === index"
                                 class="right_icon">
                                <el-dropdown @command="(v) => selectType(v, index, 'cycle_type')"
                                             trigger="click">
                                    <span class="el-dropdown-link">
                                      <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item_d, index_d) in date_text"
                                                          :command="item_d.value"
                                                          :key="index_d">
                                            {{item_d.name}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </td>
                    <!--<td>
                        时间粒度
                        <div class="dialog_btn"
                             @click="openDialog(item,index, 'frequency')">
                            {{item.frequency | filter_frequency}}
                        </div>
                    </td>-->
                    <td>
                        <!--推送时间-->
                        <!-- <div class="dialog_btn"
                             @click="openDialog(item,index, 'push_time_type')">
                            {{item.push_time_type | filter_push_time_type}}
                        </div> -->
                        <div class="dialog_btn"
                             @click="openDialog(item,index, 'push_time_type')">
                            {{item.push_time | filter_push_time}}
                        </div>
                    </td>
                    <td>
                        <!--模板-->
                        <div class="select_box">
                            <span class="left_text">{{originalTemplateList[item.push_template]}}</span>
                            <div v-if="edit_row_index === index"
                                 class="right_icon">
                                <el-dropdown @command="(v) => selectType(v, index, 'push_template')"
                                             trigger="click" placement="bottom">
                                    <span class="el-dropdown-link">
                                      <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item_event, index_event) in templateList"
                                                          :command="item_event.value"
                                                          :key="index_event">
                                            {{item_event.label}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </td>
                    <td>{{item.cycle_type | filter_cycle_type}}</td>
                    <td class="text_width_td"
                        v-for="(item_l, index_l) in columnData"
                        :key="index_l">
                        <div v-if="item.cycle_type!='T'" class="td_text">
                            <div v-for="(item_c, index_c) in item_l.cycle_list"
                                 :key="index_c"
                                 class="cycle_item">
                                <div v-if="item.cycle_type!='CYCLE'" class="td_text">
                                    <div v-for="(item_w, index_w) in item_c.week_month_list"
                                         :key="index_w"
                                         class="week_item">
                                        <div v-if="item.cycle_type==='WM'"
                                             :class="item_c.week_month_list.length-1===index_w
                                        && item_l.cycle_list.length-1===index_c
                                        ?'last_text':''"
                                             @click="openSelectPage(item_w.cycle_id, item)"
                                             v-text="showCycleText(item_w.cycle_id, item, 'small')"
                                             class="item_text top_text">
                                            <!--治疗周-->
                                        </div>
                                    </div>
                                </div>
                                <div v-if="item.cycle_type==='CYCLE'"
                                     :class="item_l.cycle_list.length-1===index_c?'last_text':''"
                                     @click="openSelectPage(item_c.cycle_id, item)"
                                     v-text="showCycleText(item_c.cycle_id, item)"
                                     class="item_text">
                                    <!--Cycle-->
                                </div>
                            </div>
                        </div>
                        <div v-if="item.cycle_type==='T'"
                             @click="openSelectPage(item_l.cycle_id, item)"
                             v-text="showCycleText(item_l.cycle_id, item)"
                             class="bottom_text">
                            <!--T次-->
                        </div>
                    </td>
                </tr>
                <tr class="table_td">
                    <td class="first_td">
                        <div class="btn_text add_text" @click="addRow">
                            + 新增
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <!--
        <el-dialog
                title="时间粒度"
                :visible.sync="dialogVisible_size"
                :modal-append-to-body="false"
                :show-close="false"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                width="700px">
            <div class="dialog_box">
                <el-form :model="size_form"
                         :rules="size_rules"
                         :disabled="look_type === 'look'"
                         label-width="100px">
                    <el-form-item label="规则：">
                        <div class="input_box">
                            <div v-for="(item, index) in size_type_list"
                                 :key="index"
                                 :class="size_form.size_type === item.value?'actived_btn':''"
                                 @click="changeSizeType(item.value)"
                                 class="btn">
                                {{item.name}}
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div v-if="size_form.size_type === 'DAY'">
                            <span>每隔 </span>
                            <span>
                            <el-input-number v-model="size_form.days"
                                             class="width_150"
                                             controls-position="right"
                                             :min="1"></el-input-number>
                        </span>
                            <span> 天</span>
                        </div>
                        <div v-if="size_form.size_type === 'MONTH'">
                            <el-checkbox-group v-model="size_form.day_list">
                                <el-checkbox v-for="(item, index) in monthDays"
                                             :label="item"
                                             :key="index"></el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-if="size_form.size_type === 'WEEK'">
                            <el-checkbox-group v-model="size_form.day_list">
                                <el-checkbox v-for="(item, index) in weekDays"
                                             :label="item"
                                             :key="index"></el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-if="size_form.size_type === 'TREAT_WEEK'">
                            <el-checkbox-group v-model="size_form.day_list">
                                <el-checkbox v-for="(item, index) in cureWeekDays"
                                             :label="item"
                                             :key="index">
                                    第{{item}}天
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-if="size_form.size_type === 'CYCLE_DAY'">
                            <el-checkbox-group v-model="size_form.day_list">
                                <el-checkbox v-for="(item, index) in cycleDays"
                                             :label="item"
                                             :key="index">
                                    {{item}}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="close_dialog('frequency')">取 消</el-button>
              <el-button type="primary"
                         v-if="look_type === 'edit'"
                         @click="submit_dialog('frequency')">确 定</el-button>
            </span>
        </el-dialog>-->
        <el-dialog
                title="推送时间"
                :visible.sync="dialogVisible_date"
                :modal-append-to-body="false"
                :show-close="false"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                width="550px">
            <div class="dialog_box">
                <el-form :disabled="look_type === 'look'">
                    <el-button type="primary" @click="addDataTime" size="small">添加</el-button>
                    <div class="item_" v-for="(item,index) in dataTimes" :key="index">
                        <div>
                            <el-dropdown @command="handleCommand($event,index)">
                                <span>
                                {{item.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="1">立即</el-dropdown-item>
                                    <el-dropdown-item command="2">延迟</el-dropdown-item>
                                    <el-dropdown-item command="3">定时</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <span v-if="item._id == 2">
                                <el-input-number
                                        v-model="item.minute"
                                        size="mini"
                                        controls-position="right"
                                        :min="1"
                                        style="width:100px;"
                                >
                                </el-input-number>
                                分钟
                            </span>
                            <template v-if="item._id == 3">
                                <el-input-number
                                        v-model="item.day"
                                        size="mini"
                                        controls-position="right"
                                        :min="0"
                                        style="width:100px;"
                                >
                                </el-input-number>
                                天
                                <el-time-picker
                                        v-model="item.time"
                                        size="mini"
                                        format="HH:mm"
                                        value-format="HH:mm"
                                        placeholder="时分">
                                </el-time-picker>
                            </template>
                        </div>
                        <el-button @click="del_list(index)" size="small">删除</el-button>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="close_dialog('push_time_type')">取 消</el-button>
              <el-button type="primary"
                         v-if="look_type === 'edit'"
                         @click="submit_dialog('push_time_type')">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="名称"
                   :visible.sync="dialogVisible_add"
                   :modal-append-to-body="false"
                   :show-close="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   width="400px">
            <el-form :model="add_form"
                     :rules="add_form_rule"
                     ref="add_form"
                     label-width="80px">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="add_form.name"
                              @keyup.enter.native="submit_dialog('add')"
                              class="width_220"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="close_dialog('add')">取 消</el-button>
              <el-button type="primary" @click="submit_dialog('add')">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="活动推送"
                   :visible.sync="showActivityPush"
                   :modal-append-to-body="false"
                   :show-close="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   width="700px">
            <el-form :model="activityPushForm" label-width="80px" class="form_box">
                <div class="form_title">
                    <span>使用药物</span>
                </div>
                <div class="check_btn_box">
                    <div v-for="(item, index) in drugCodeList"
                         :key="index"
                         @click="checkOtherOne(item, 'drug_code_list')"
                         :class="item.checked ? 'active_btn':''"
                         class="check_btn">
                        {{item.name}}
                    </div>
                </div>
                <div class="form_title">
                    <span>癌种</span>
                </div>
                <div v-for="(item, index) in tumour_list"
                     class="check_item"
                     :key="index">
                    <div @click="checkAll(item)"
                         :class="item.checked?'active_btn':''"
                         class="check_title_btn">
                        {{item.tumour_type}}
                    </div>
                    <div class="check_btn_box">
                        <div v-for="(items, indexs) in item.tumour_list"
                             :key="indexs"
                             @click="checkOne(items, item)"
                             :class="items.checked?'active_btn':''"
                             class="check_btn">
                            {{items.name}}
                        </div>
                    </div>
                </div>

                <div class="form_title">
                    <span>用药阶段</span>
                </div>
                <div class="check_btn_box">
                    <div v-for="(item, index) in stage_list"
                         :key="index"
                         @click="checkOtherOne(item, 'medication_status')"
                         :class="item.checked?'active_btn':''"
                         class="check_btn">
                        {{item.name}}
                    </div>
                </div>
                <div class="date_">
                    <el-form-item label="距离复诊日期小于等于：" prop="less_medication_days" :inline-message="true">
                        <el-input
                                v-model="activityPushForm.less_medication_days"
                                placeholder="请输入"
                                clearable
                                size="mini"
                                style="width:150px;"
                        >
                        </el-input>
                        天
                    </el-form-item>
                    <el-form-item label="超过复诊日期大于等于：" prop="over_medication_days" :inline-message="true">
                        <el-input
                                v-model="activityPushForm.over_medication_days"
                                placeholder="请输入"
                                clearable
                                size="mini"
                                style="width:150px;"
                        >
                        </el-input>
                        天
                    </el-form-item>
                </div>

                <div class="form_title">
                    <span>基本信息</span>
                </div>
                <el-form-item label="身份:">
                    <div class="check_btn_box">
                        <div v-for="(item, index) in relation_list"
                             :key="index"
                             @click="checkOtherOne(item, 'relations')"
                             :class="item.checked?'active_btn':''"
                             class="check_btn">
                            {{item.name}}
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="来源:">
                    <div class="check_btn_box">
                        <div v-for="(item, index) in type_list"
                             :key="index"
                             @click="checkOtherOne(item, 'reg_types')"
                             :class="item.checked?'active_btn':''"
                             class="check_btn">
                            {{item.name}}
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="状态:">
                    <div class="check_btn_box">
                        <div v-for="(item, index) in status_list"
                             :key="index"
                             @click="checkOtherOne(item, 'patient_status')"
                             :class="item.checked?'active_btn':''"
                             class="check_btn">
                            {{item.name}}
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="体验:">
                    <div class="check_btn_box">
                        <div v-for="(item, index) in experience_list"
                             :key="index"
                             @click="checkOtherOne(item, 'has_visited')"
                             :class="item.checked?'active_btn':''"
                             class="check_btn">
                            {{item.name}}
                        </div>
                    </div>
                </el-form-item>
                <div class="form_title">
                </div>
                <el-form-item label="活动链接:">
                    <el-input placeholder="请输入" v-model="activityPushForm.activeLink" size="mini" style="width:400px;">
                    </el-input>
                </el-form-item>
                <div style="padding: 0 10px;">
                    参与活动获得
                    <el-input placeholder="请输入" v-model="activityPushForm.integralCount" size="mini"
                              style="width:80px;">
                    </el-input>
                    积分
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="showActivityPush = false;">取 消</el-button>
              <el-button type="primary" @click="activityPushSubmit">确 定</el-button>
            </span>
        </el-dialog>

        <div class="component_box" v-if="show_component">
            <component :is="component_id"
                       :push_config_id="push_config_id"
                       :cycle_id="cycle_id"
                       :look_type="look_type"
                       :user_form="user_form"
                       @changeSomeCode="changeSomeCode"
                       :ref="component_id"></component>
        </div>
    </div>
</template>

<script>
    import {clone} from "@/global/utils";
    import {mapState, mapMutations} from "vuex"
    import articleView from "./articleView"
    import videoView from "./videoView"
    import questionView from "./questionView"
    import greetingView from "./greetingsView"
    import comRemindView from "./comRemindView"
    import targetTypeView from "./targetTypeView"

    let self;
    export default {
        name: "tableView",
        components: {
            articleView,
            videoView,
            questionView,
            greetingView,
            comRemindView,
            targetTypeView,
        },
        data() {
            return {
                // 选择图文、调研、问候语、通用提醒所需参数和控制条件
                component_id: '',
                show_component: false,
                push_config_id: null,
                cycle_id: null,

                searchForm: {
                    input: ''
                },

                tableData: [],
                columnData: [],

                edit_row_index: -1, // 确保每次都只有一个已知数据进行新增或修改
                edit_row_clone: null, // 取消修改之后重置数据

                push_text: [
                    {name: '图文', value: 'PAPER'},
                    {name: '视频', value: 'VIDEO'},
                    {name: '调研', value: 'SURVEY'},
                    {name: '问候语', value: 'GREETING'},
                    {name: '通用提醒', value: 'G_REMIND'},
                    {name: '固定模板', value: 'TEMPLATE'},
                ],
                sort_text: [
                    {name: '顺序', value: '1'},
                    {name: '随机', value: '2'},
                ],
                date_text: [
                    {name: '治疗周', value: 'WM'},
                    {name: 'Cycle', value: 'CYCLE'},
                    {name: 'T次', value: 'T'},
                    {name: '无需设置', value: 'DEFAULT'},
                ],
                dataTime: 1,
                dataTimes: [],
                eventList: [],
                templateList: [],
                user_text: [
                    {
                        name: '患者',
                        value: 'PATIENT',
                    },
                ],
                relation_list: [
                    {name: '本人', value: '1'},
                    {name: '家属', value: '2'},
                    {name: '朋友', value: '3'},
                ],

                dialogVisible_user: false,
                dialogVisible_size: false,
                dialogVisible_date: false,
                dialogVisible_add: false,
                edit_add_item: null, // 正在修改（新增）的数据

                // 新增规则模块
                add_form: {
                    name: '',
                },
                add_form_rule: {
                    name: [{required: true, message: '请输入规则名称', trigger: 'blur'}]
                },

                user_form: {},
                user_rules: {
                    user_type: [{required: true, message: '请选择目标身份', trigger: 'blur'}]
                },
                tumour_list: [],

                size_form: {},
                size_rules: {
                    size_type: [{required: true, message: '请选择时间粒度', trigger: 'blur'}]
                },
                size_type_list: [
                    {name: '按天', value: 'DAY'},
                    {name: '按治疗周', value: 'TREAT_WEEK'},
                    {name: '按自然周', value: 'WEEK'},
                    {name: '按月', value: 'MONTH'},
                    {name: '周期', value: 'CYCLE_DAY'},
                ],
                weekDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日',],
                cureWeekDays: ['1', '2', '3', '4', '5', '6', '7',],
                monthDays: [
                    '1', '2', '3', '4', '5', '6', '7', '8', '9', '10',
                    '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
                    '21', '22', '23', '24', '25', '26', '27', '28',
                    '月末'
                ],
                cycleDays: ['第1天', '第2天', '第3天', '第4天', '第5天', '期中', '末1天', '末2天', '末3天', '末4天', '末5天'],

                date_form: {},
                date_rules: {},
                date_type_list: [
                    {name: '时间点', value: 'POINT'},
                    {name: '时间段', value: 'RANGE'},
                ],
                showActivityPush: false, //活动推送
                activityPushForm: {
                    drug_code_list: [],
                    tumour_ids: [],
                    medication_status: [],
                    less_medication_days: '',
                    over_medication_days: '',
                    relations: [],
                    reg_types: [],
                    patient_status: [],
                    has_visited: '',
                    activeLink: '',
                    integralCount: 10
                },
                drugCodeList: [],
                tumour_list: [],
                stage_list: [
                    {name: '用药周期中', value: '1'},
                    {name: '待提醒', value: '2'},
                    {name: '已脱落', value: '3'},
                ],
                relation_list: [
                    {name: '本人', value: '1'},
                    {name: '家属', value: '2'},
                    {name: '朋友', value: '3'},
                ],
                type_list: [
                    {name: '助手码', value: '1'},
                    {name: '自然渠道', value: '2'},
                    {name: '医护码', value: '3'},
                ],
                status_list: [
                    {name: '已注册', value: '1'},
                    {name: '未审核', value: '2'},
                    {name: '审核通过', value: '3'},
                    {name: '审核未通过', value: '4'},
                ],
                experience_list: [
                    {name: '已使用', value: 1},
                    {name: '未使用', value: 2},
                ],
            }
        },
        computed: {
            ...mapState("comInformationData", {
                tumour_type_dict: 'tumour_type_dict',
                drug_code_list: 'drug_code_list',
                tumour_type_dict: 'tumour_type_dict'
            }),
            look_type() {
                // 查看、修改 图文等
                return this.edit_row_index === -1 ? 'look' : 'edit'
            },

        },
        filters: {
            filter_content_type(e) {
                let text = '';
                self.push_text.forEach(v => {
                    if (v.value == e) {
                        text = v.name
                    }
                });
                return text
            },
            filter_content_order(e) {
                let text = '';
                self.sort_text.forEach(v => {
                    if (v.value == e) {
                        text = v.name
                    }
                });
                return text
            },
            filter_target_type(item) {
                let text = '未选';
                // console.log(e, '596');
                if (item.tumour_ids ||
                    item.relations ||
                    item.drug_code_list ||
                    item.reg_types ||
                    item.patient_status ||
                    item.medication_status) {
                    text = '已选'
                }
                return text
            },
            filter_cycle_type(e) {
                let text = '';
                self.date_text.forEach(v => {
                    if (v.value == e) {
                        text = v.name
                    }
                });
                return text
            },
            filter_frequency(e) {
                let text = '';
                self.size_type_list.forEach(v => {
                    if (v.value == e) {
                        text = v.name
                    }
                });
                return text
            },
            filter_push_time_type(e) {
                let text = '';
                self.date_type_list.forEach(v => {
                    if (v.value == e) {
                        text = v.name
                    }
                });
                return text
            },
            filter_push_time(list) {
                let text = '';
                if (list) {
                    if (typeof list == 'string') {
                        list = JSON.parse(list)
                    }
                    if (Array.isArray(list) && list[0]) {
                        let item = list[0];
                        if (item._id == 1) {
                            text = '立即';
                        } else if (item._id == 2) {
                            text = `${item.name}${item.minute}分钟`
                        } else if (item._id == 3) {
                            text = `${item.name}${item.day}天后${item.time}`
                        }
                    } else {
                        return text;
                    }
                }
                return text
            }
        },
        beforeCreate() {
            self = this;
        },
        mounted() {
            // this.getTumour(); // 旧方法 目标人员选择癌种
            this.drugCodeList = clone(this.drug_code_list);
            this.tumour_list = clone(this.tumour_type_dict);
            console.log("tumour_list", this.tumour_list)
            this.getColumnData()
            this.getPushEvent();
            this.getPushTemplate();
        },
        methods: {
            ...mapMutations('manageData', {
                setBaseContentType: 'setBaseContentType',
                setNowContentType: 'setNowContentType',
            }),
            activityPush() {
                //活动推送
                this.showActivityPush = true;
            },
            checkOtherOne(item, type) {
                item.checked = !item.checked;
                this.$forceUpdate();
                this.activityPushForm[type] = [];
                switch (type) {
                    case 'medication_status':
                        this.stage_list.forEach(v => {
                            if (v.checked) {
                                this.activityPushForm[type].push(v.value)
                            }
                        });
                        break;
                    case 'relations':
                        this.relation_list.forEach(v => {
                            if (v.checked) {
                                this.activityPushForm[type].push(v.value)
                            }
                        });
                        break;
                    case 'reg_types':
                        this.type_list.forEach(v => {
                            if (v.checked) {
                                this.activityPushForm[type].push(v.value)
                            }
                        });
                        break;
                    case 'patient_status':
                        this.status_list.forEach(v => {
                            if (v.checked) {
                                this.activityPushForm[type].push(v.value)
                            }
                        });
                    case 'drug_code_list':
                        this.drugCodeList.forEach(v => {
                            if (v.checked) {
                                this.activityPushForm[type].push(v.drug_code)
                            }
                        });
                        break;
                    case 'has_visited':
                        this.activityPushForm[type] = '';
                        this.experience_list.forEach(v => {
                            if (v.checked) {
                                this.activityPushForm[type] = v.value;
                            }
                        });
                        break;
                }
            },
            activityPushSubmit() {

            },
            // 执行推送
            push_now() {
                this.httpGet('/push/run').then(res => {
                    this.$message.success('推送成功')
                })
            },

            getTumour() {
                this.tumour_list = clone(this.tumour_type_dict);
                this.tumour_list.map(v => {
                    v.checked = false;
                    v.tumour_list.map(e => e.checked = false)
                })
            },
            refreshTumour(ids) {
                if (ids) {
                    this.tumour_list.map(v => {
                        v.tumour_list.map(e => {
                            if (ids.indexOf(e.tumour_id) > -1 ||
                                ids.indexOf(String(e.tumour_id)) > -1) {
                                e.checked = true
                            }
                        })
                    });
                    this.tumour_list.map(v => {
                        let all = true;
                        v.tumour_list.map(e => {
                            if (e.checked === false) {
                                all = false
                            }
                        });
                        v.checked = all
                    })
                } else {
                    this.tumour_list.map(v => {
                        v.checked = false;
                        v.tumour_list.map(e => e.checked = false)
                    })
                }
            },

            showCycleText(cycle_id, item, small) {
                // 展示当前cell的内容（T次，Cycle，治疗周）
                let text = '无';
                let type = '';
                this.push_text.map(v => {
                    if (v.value == item.content_type) {
                        type = v.name
                    }
                });
                let num = 0;
                if (item.cycle_list && item.cycle_list.length > 0) {
                    item.cycle_list.map(v => {
                        if (v.cycle_id == cycle_id) {
                            num = v.content_ids ? v.content_ids.length : 0
                        }
                    });
                    if (num > 0) {
                        text = small ? `${num}条` : `已选${num}条${type}`
                    }
                }

                return text
            },

            // 选择图文、调研等页面返回的参数
            changeSomeCode(params) {
                if (params) {
                    if (params.type && params.type === 'target_type') {
                        //    目标人员点击确定之后
                        this.edit_add_item.tumour_ids = params.form.tumour_ids.join(',');
                        this.edit_add_item.medication_status = params.form.medication_status.join(',');
                        this.edit_add_item.drug_code_list = JSON.stringify(params.form.drug_code_list);
                        this.edit_add_item.relations = params.form.relations.join(',');
                        this.edit_add_item.reg_types = params.form.reg_types.join(',');
                        this.edit_add_item.patient_status = params.form.patient_status.join(',');
                        this.edit_add_item.has_visited = params.form.has_visited;
                        this.edit_add_item.less_medication_days = params.form.less_medication_days;
                        this.edit_add_item.over_medication_days = params.form.over_medication_days;
                        this.show_component = false;
                    } else {
                        this.submitSelectRow(params)
                    }

                } else {
                    this.show_component = false;
                }
            },
            openSelectPage(id, item) {
                // 图文、调研、问候语、提醒打开页面通用方法
                // console.log(id, item, '737');
                // 编辑状态只能打开正在编辑的数据
                if (this.edit_add_item && this.edit_add_item.push_config_id && item.push_config_id != this.edit_add_item.push_config_id) return;

                this.cycle_id = id; // 选中的周期ID
                if (item.content_type) {
                    // 有推送内容才能打开图文、调研等
                    this.push_config_id = item.push_config_id;
                    this.changeContent_type(item.content_type);
                    this.show_component = true;
                } else {
                    this.$message.warning('请选择推送内容')
                }

            },
            selectTarget(item, index) {
                //    目标人员 打开页面方法

                // 编辑状态只能打开正在编辑的数据
                if (this.edit_add_item && this.edit_add_item.push_config_id && item.push_config_id != this.edit_add_item.push_config_id) return;

                this.component_id = 'targetTypeView';
                const that = this;
                // that.refreshTumour();
                setTimeout(() => {
                    console.log(item, '1114');
                    if (item.push_config_id) {
                        that.user_form = {
                            user_type: item.target_type,
                            tumour_ids: item.tumour_ids ? item.tumour_ids.split(',') : [],
                            // drug_code_list: item.drug_code_list?item.drug_code_list.split(','):[],
                            drug_code_list: item.drug_code_list ? JSON.parse(item.drug_code_list) : [],
                            medication_status: item.medication_status ? item.medication_status.split(',') : [],
                            relations: item.relations ? item.relations.split(',') : [],
                            reg_types: item.reg_types ? item.reg_types.split(',') : [],
                            patient_status: item.patient_status ? item.patient_status.split(',') : [],
                            has_visited: item.has_visited,
                            less_medication_days: item.less_medication_days,
                            over_medication_days: item.over_medication_days,
                        };
                        // that.refreshTumour(this.user_form.tumour_ids)
                    } else {
                        that.user_form = {
                            user_type: 'PATIENT',
                            tumour_ids: [],
                            medication_status: [],
                            relations: [],
                            reg_types: [],
                            patient_status: []
                        };
                    }
                    console.log(this.user_form, 'user------');
                    this.show_component = true;
                }, 5);
            },

            addRow() {
                if (this.edit_row_index > -1) {
                    this.$message.warning('已有数据正在进行新增（修改）');
                    return
                }
                this.add_form = {
                    name: '',

                    content_type: '', // 推送内容
                    content_order: '', // 内容顺序
                    target_type: '', // 目标人员
                    tumour_ids: '',
                    cycle_type: 'T', // 时间类型
                    // frequency: '', // 时间粒度
                    frequency_detail: '',
                    push_time_type: '', // 推送时间
                    push_time_detail: '',
                    push_time: '',
                };
                this.dialogVisible_add = true;
                this.$nextTick(() => this.$refs.add_form.clearValidate())
            },
            editRow(item, index) {
                if (this.edit_row_index > -1) {
                    this.$message.warning('已有数据正在进行新增（修改）');
                    return
                }
                this.edit_add_item = item;
                this.edit_row_index = index;
                this.edit_row_clone = clone(item);
                this.push_config_id = item.push_config_id; // 选中的规则ID
                this.setBaseContentType(this.edit_add_item.content_type); // 上次推送内容
                this.setNowContentType(''); // 当前推送内容
                this.changeContent_type(item.content_type)
            },
            changeContent_type(type) {
                // 切换选择页面 图文、调研、问候语、通用提醒
                // console.log(type, '825---');
                switch (type) {
                    case 'PAPER':
                        this.component_id = 'articleView';
                        break;
                    case 'VIDEO':
                        this.component_id = 'videoView';
                        break;
                    case 'SURVEY':
                        this.component_id = 'questionView';
                        break;
                    case 'GREETING':
                        this.component_id = 'greetingView';
                        break;
                    case 'G_REMIND':
                        this.component_id = 'comRemindView';
                        break;
                }
            },
            submitRow(item, msg = '保存成功') {
                // console.log(item, '306---submit----');
                let params = {...item};
                params.drug_code_list = params.drug_code_list ? Array.isArray(params.drug_code_list) ? params.drug_code_list : JSON.parse(params.drug_code_list) : ''
                this.httpPost('/push/config/save', params).then(res => {
                    this.edit_add_item = null;
                    this.component_id = null;
                    this.edit_row_index = -1;
                    this.getTableData();
                    this.$message.success(msg)
                })
            },
            cancelRow(item, index) {
                if (item.push_config_id) {
                    this.tableData[this.edit_row_index] = this.edit_row_clone;
                    // this.$forceUpdate()
                } else {
                    this.tableData.splice(index, 1)
                }
                this.edit_add_item = null;
                this.edit_row_clone = null;
                this.edit_row_index = -1;
            },
            upLineRow(item) {
                let params = {
                    status: 2,
                    push_config_id: item.push_config_id
                };
                console.log(item, '854');
                let warning = '';
                if (!item.name) {
                    warning = '请输入名称'
                } else if (!item.content_type) {
                    warning = '请选择推送内容'
                } else if (!item.content_order) {
                    warning = '请选择内容顺序'
                } else if (!(item.tumour_ids ||
                    item.relations ||
                    item.reg_types ||
                    item.patient_status ||
                    item.medication_status)) {
                    warning = '请选择目标人员'
                } else if (!item.cycle_type) {
                    warning = '请选择时间类型'
                    // } else if(!item.frequency) {
                    //     warning = '请选择时间粒度'
                } else if (!item.push_time_type) {
                    warning = '请选择推送时间'
                }
                if (warning) {
                    this.$message.warning(warning)
                } else {
                    this.submitRow(params, '发布成功');
                }
            },
            downLineRow(item) {
                let params = {
                    status: 1,
                    push_config_id: item.push_config_id
                };
                this.submitRow(params, '下线成功');
            },
            delRow(item) {
                this.$confirm('确认要删除该规则么？').then(() => {
                    this.httpDel(`/push/config/${item.push_config_id}`).then(res => {
                        this.$message.success('删除成功');
                        this.getTableData()
                    })
                })
            },

            submitSelectRow(params) {
                // 提交选择的图文、调研、问候语、通用提醒
                params.content_type = this.edit_add_item.content_type;
                // console.log(params, '594');
                this.httpPost('/push/content/save', params).then(res => {
                    // this.getTableData()
                    this.edit_add_item.cycle_list.forEach(v => {
                        if (v.cycle_id == params.cycle_id) {
                            v.content_ids = params.content_ids
                        }
                    });
                    this.show_component = false;
                    this.setBaseContentType(this.edit_add_item.content_type); // 上次推送内容
                })
            },

            selectType(v, index, name) {
                console.log(v, index, name, this.edit_add_item, 'selectType');
                this.tableData[index][name] = v;
                if (name === 'content_type') {
                    this.changeContent_type(v);
                    this.setNowContentType(v); // 当前推送内容
                }
            },
            del_list(index) {
                this.dataTimes.splice(index, 1);
            },
            handleCommand(command, index) {
                let obj = {};
                obj._id = command;
                if (command == 1) {
                    obj.name = '立即';
                } else if (command == 2) {
                    obj.name = '延迟';
                    obj.minute = 1;

                } else if (command == 3) {
                    obj.name = '定时';
                    obj.day = 0;
                    obj.time = '';
                }
                this.$set(this.dataTimes, index, obj);
            },
            addDataTime() {
                let obj = {};
                obj.name = '立即';
                obj._id = 1;
                this.dataTimes.push(obj);
            },
            openDialog(item, index, type) {
                // 编辑状态只能打开正在编辑的数据
                if (this.edit_add_item && this.edit_add_item.push_config_id && item.push_config_id != this.edit_add_item.push_config_id) return;
                // console.log(typeof item.push_time, '1323');
                switch (type) {
                    case 'frequency':
                        if (item.push_config_id) {
                            this.size_form = {
                                size_type: item.frequency || 'DAY',
                                days: 1,
                                day_list: []
                            };
                            if (this.size_form.size_type === 'DAY') {
                                this.size_form.days = item.frequency_detail
                            } else {
                                this.size_form.day_list = item.frequency_detail.split(',')
                            }
                        } else {
                            this.size_form = {
                                size_type: 'DAY',
                                days: '',
                                day_list: []
                            };
                        }
                        this.dialogVisible_size = true;
                        break;
                    case 'push_time_type':
                        // if (item.push_config_id) {
                        //     this.date_form = {
                        //         date_type: item.push_time_type || 'POINT',
                        //         date_one: '',
                        //         date_two: []
                        //     };
                        //     if (this.date_form.date_type === "POINT") {
                        //         this.date_form.date_one = item.push_time_detail
                        //     } else {
                        //         this.date_form.date_two = item.push_time_detail.split(',')
                        //     }
                        // } else {
                        //     this.date_form = {
                        //         date_type: 'POINT',
                        //         date_one: '',
                        //         date_two: []
                        //     };
                        // }
                        if (item.push_time && item.push_time !== 'null') {
                            this.dataTimes = typeof item.push_time == 'string' ?
                                JSON.parse(item.push_time) : item.push_time;
                            // this.dataTimes = item.push_time;
                        } else {
                            this.dataTimes = [];
                        }
                        // this.dataTimes = item.push_time ? JSON.parse(item.push_time) : [];
                        this.dialogVisible_date = true;
                        break;
                }
            },
            close_dialog(type) {
                switch (type) {
                    case 'target_type':
                        this.dialogVisible_user = false;
                        break;
                    case 'frequency':
                        this.dialogVisible_size = false;
                        break;
                    case 'push_time_type':
                        this.dialogVisible_date = false;
                        break;
                    case 'add':
                        this.dialogVisible_add = false;
                        break;
                }
            },
            submit_dialog(type) {
                // console.log(this.edit_add_item, 'submit-dialog-----580');
                switch (type) {
                    case 'frequency':
                        this.edit_add_item.frequency = this.size_form.size_type;
                        let text = '';
                        if (this.size_form.size_type === 'DAY') {
                            text = this.size_form.days
                        } else {
                            text = this.size_form.day_list.join(',')
                        }
                        this.edit_add_item.frequency_detail = text;
                        this.dialogVisible_size = false;
                        break;
                    case 'push_time_type':
                        // this.edit_add_item.push_time_type = this.date_form.date_type;
                        // let text1 = '';
                        // if (this.date_form.date_type === 'POINT') {
                        //     text1 = this.date_form.date_one
                        // } else {
                        //     text1 = this.date_form.date_two.join(',')
                        // }
                        // this.edit_add_item.push_time_detail = text1;
                        this.edit_add_item.push_time = this.dataTimes;
                        this.dialogVisible_date = false;
                        break;
                    case 'add':
                        this.$refs.add_form.validate(valid => {
                            if (valid) {
                                let params = {...this.add_form};
                                this.httpPost('/push/config/save', params).then(res => {
                                    this.getTableData('add');
                                    this.dialogVisible_add = false;
                                });
                            }
                        });
                        break;
                }
            },

            // 目标人员
            checkAll(item) {
                item.checked = !item.checked;
                item.tumour_list.map(v => v.checked = item.checked);
                this.getTumourIds()
            },
            checkOne(items, item) {
                items.checked = !items.checked;
                let all = true;
                item.tumour_list.map(v => {
                    if (!v.checked) {
                        all = false
                    }
                });
                item.checked = all;
                this.getTumourIds()
            },
            getTumourIds() {
                this.user_form.tumour_ids = [];
                this.tumour_list.forEach(v => {
                    v.tumour_list.forEach(e => {
                        if (e.checked) {
                            this.user_form.tumour_ids.push(e.tumour_id)
                        }
                    })
                });
                this.$forceUpdate(); // 数据修改后刷新页面
                // console.log(this.user_form, 'user_form------605');
            },
            // 时间粒度
            changeSizeType(val) {
                if (this.size_form.size_type === val) return;
                this.size_form.size_type = val;
                this.size_form.days = '';
                this.size_form.day_list = [];
            },
            // 推送时间
            changeDateType(val) {
                if (this.look_type === 'look') return; // 查看状态
                if (this.date_form.date_type === val) return;
                this.date_form.date_type = val;
                this.date_form.date_one = '';
                this.date_form.date_two = [new Date(), new Date()];
            },

            getColumnData() {
                this.httpGet('/push/cycle').then(res => {
                    this.columnData = res.data;
                    this.getTableData()
                })
            },
            getPushEvent() {
                this.httpGet("/push/push_event").then(res => {
                    let data = res.data;
                    let list = []
                    if (data) {
                        let keys = Object.keys(data);
                        keys.forEach(key => {
                            list.push({
                                value: key,
                                label: data[key]
                            })
                        })
                    }
                    this.originalEventList = data;
                    this.eventList = list;
                })
            },
            getPushTemplate() {
                this.httpGet("/push/push_template").then(res => {
                    let data = res.data;
                    let list = []
                    if (data) {
                        let keys = Object.keys(data);
                        keys.forEach(key => {
                            list.push({
                                value: key,
                                label: data[key]
                            })
                        })
                    }
                    this.originalTemplateList = data;
                    this.templateList = list;
                })
            },
            getTableData(type) {
                let params = {
                    name: this.searchForm.input
                };
                this.httpGet('/push/config/list', params).then(res => {
                    this.tableData = res.data;
                    if (type && type === 'add') {
                        let index_ = res.data.length - 1;
                        this.edit_add_item = res.data[index_];
                        this.push_config_id = this.edit_add_item.push_config_id; // 选中的规则ID
                        this.edit_row_index = index_;
                        this.setBaseContentType(''); // 上次推送内容
                        this.setNowContentType(''); // 当前推送内容
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    $border_color1: #ccc;
    /*border-bottom: 1px solid #EBEEF5;*/
    .context {
        width: 100%;
        height: 100%;
        position: relative;
        .header {
            z-index: 99;
        }
        .table {
            z-index: 99;
            width: 100%;
            overflow: auto;
            white-space: nowrap;
            padding: 0 10px;
            box-sizing: border-box;
            .table_th {
                font-size: .875rem;
                color: #909399;
                background: rgba(243, 247, 249, 1);
                box-sizing: border-box;
                text-align: center;
                th {
                    border-top: 1px solid $border_color1;
                    border-right: 1px solid $border_color1;
                    border-bottom: 1px solid $border_color1;
                    box-sizing: border-box;
                    .th_text {
                        line-height: 30px;
                        border-bottom: 1px solid $border_color1;
                        box-sizing: border-box;
                    }
                    .bottom_text {
                        line-height: 30px;
                    }
                }

                .left_th {
                    div {
                        width: 90px;
                        padding: 0 5px;
                        box-sizing: border-box;
                    }
                    .lang_left_th {
                        width: 120px;
                    }
                }
                .first_th {
                    border-left: 1px solid $border_color1;
                    div {
                        width: 120px;
                    }
                }

                .text_width_1 {
                    .th_text {
                        display: flex;
                        .item_text {
                            flex: 1;
                            padding: 0 5px;
                            border-right: 1px solid $border_color1;
                            box-sizing: border-box;
                        }
                        .top_text {
                            width: 70px;
                        }
                        .last_text {
                            border-right: none;
                        }
                    }

                }
            }
            .table_td {
                text-align: center;
                line-height: 30px;
                font-size: .875rem;
                .first_td {
                    border-left: 1px solid $border_color1;
                }
                td {
                    border-right: 1px solid $border_color1;
                    border-bottom: 1px solid $border_color1;
                    box-sizing: border-box;
                    .btn_text {
                        cursor: pointer;
                        padding: 0 5px;
                        font-size: .8rem;
                    }
                    .add_text {
                        color: #909399;
                    }
                    .submit_btn {
                        color: #67C23A;
                    }
                    .down_line {
                        color: #F56C6C;
                    }
                    .edit_btn {
                        color: #409EFF;
                    }

                    .select_box {
                        display: flex;
                        .left_text {
                            flex: 1;
                        }
                        .right_icon {
                            flex: 0 0 30px;
                            cursor: pointer;
                        }
                    }
                    .dialog_btn {
                        width: 100%;
                        height: 30px;
                        cursor: pointer;
                    }
                }
                .text_width_td {
                    cursor: pointer;
                    .td_text {
                        display: flex;
                        .cycle_item {
                            flex: 1;
                        }
                        .item_text {
                            flex: 1;
                            padding: 0 5px;
                            border-right: 1px solid $border_color1;
                            box-sizing: border-box;
                        }
                        .top_text {
                            width: 70px;
                        }
                        .last_text {
                            border-right: none;
                        }
                    }
                    .bottom_text {
                        width: 100%;
                    }
                }
            }
            .table_edit_row {
                background: rgb(236, 245, 255);
                /*background: #f5f7fa;*/
            }
        }

        .dialog_box {
            .input_box {
                display: flex;
                box-sizing: border-box;
                .btn {
                    height: 25px;
                    line-height: 25px;
                    font-size: .875rem;
                    padding: 0 10px;
                    box-sizing: border-box;
                    margin: 7px 10px;
                    cursor: pointer;
                }
                .actived_btn {
                    box-sizing: border-box;
                    border: 1px solid #38adff;
                    border-radius: 3px;
                }
                .el-checkbox-group {
                    height: 40px !important;
                }
            }

            .check_item {
                display: flex;
                white-space: nowrap;
                line-height: 15px;
                box-sizing: border-box;
                padding: 8px 0;

                .check_title_btn {
                    text-align: center;
                    margin: 5px 10px;
                    padding: 5px;
                    width: 60px;
                    height: 15px;
                    cursor: pointer;
                    background: #F2F6FC;
                    border: 1px solid #f2f6fc;
                    border-radius: 2px;
                }
                .check_btn_box {
                    flex: 1;
                    display: flex;
                    flex-wrap: wrap;
                    .check_btn {
                        margin: 5px;
                        padding: 5px;
                        height: 15px;
                        cursor: pointer;
                        border: 1px solid #fff;
                        border-radius: 5px;
                    }
                    .active_btn {
                        border-color: #409EFF;
                    }
                }
                .active_btn {
                    border-color: #409EFF;
                }
            }
            .item_ {
                padding: 5px;
                border-bottom: 1px solid #ccc;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
        }

        .component_box {
            z-index: 100;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #fff;
        }
    }

    .form_box {
        flex: 1;
        overflow-y: auto;
        padding: 5px;
        box-sizing: border-box;
        font-size: .875rem;
        .form_title {
            border-bottom: 1px solid #ccc;
            line-height: 40px;
            font-size: 1rem;
            padding: 0 10px;
            margin: 5px 0;
            color: #606266;
            .remark {
                padding-left: 20px;
                color: #909399;
                font-size: .75rem;
            }
        }
        .check_item {
            display: flex;
            white-space: nowrap;
            line-height: 18px;
            box-sizing: border-box;
            .check_title_btn {
                text-align: center;
                margin: 5px 10px;
                padding: 5px;
                width: 60px;
                height: 18px;
                cursor: pointer;
                background: #F2F6FC;
                border: 1px solid #f2f6fc;
                border-radius: 2px;
            }
            .active_btn {
                border-color: #409EFF;
            }
        }
        .check_btn_box {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            line-height: 18px;
            .check_btn {
                margin: 5px;
                padding: 5px;
                height: 18px;
                cursor: pointer;
                border: 1px solid #fff;
                border-radius: 5px;
            }
            .active_btn {
                border-color: #409EFF;
            }
        }
    }
</style>
<style lang="scss">
    .table_edit_row .no_border_radius {
        border-radius: 0;
        input.el-input__inner {
            border-radius: 0;
        }

    }
</style>